<template>
  <div class="auth-wrapper auth-v2">
    <b-row class="auth-inner m-0">

      <!-- Brand logo-->
      <b-link class="brand-logo d-flex align-items-center">
        <vuexy-logo />
        <h2 class="brand-text text-primary ml-1 mb-0">
          {{ appConfig.brand }}
        </h2>
      </b-link>
      <!-- /Brand logo-->

      <!-- Left Text-->
      <b-col
        xl="8"
        lg="6"
        class="d-none d-lg-flex align-items-center p-5"
      >
        <div class="w-100 d-lg-flex align-items-center justify-content-center px-5">
          <b-img
            fluid
            :src="imgUrl"
            alt="Forgot password V2"
          />
        </div>
      </b-col>
      <!-- /Left Text-->

      <!-- Forgot password-->
      <b-col
        xl="4"
        lg="6"
        class="d-flex align-items-center auth-bg px-2 p-lg-5"
      >
        <b-col
          sm="8"
          md="6"
          lg="12"
          class="px-xl-2 mx-auto"
        >
          <b-card-title class="mb-1">
            {{ $t('Forgot Password') }} 🔒
          </b-card-title>
          <b-card-text class="mb-2">
            {{ $t('Reset Password msg') }}
          </b-card-text>

          <!-- form -->
          <validation-observer ref="forgotPasswordForm">
            <b-form
              class="auth-forgot-password-form mt-2"
              @submit.prevent="submit"
            >
              <div v-if="step === 1">
                <b-form-group
                  :label="$t('Mobile')"
                  label-for="login-mobile"
                >
                  <validation-provider
                    #default="{ errors }"
                    :name="$t('Mobile')"
                    vid="mobile"
                    rules="required"
                  >
                    <vue-phone-number-input
                      v-model="fullMobile"
                      style="direction:ltr"
                      default-country-code="IR"
                      name="mobile"
                      :state="errors.length > 0 ? false : null"
                      :placeholder="$t('Mobile')"
                      :translations="{
                        countrySelectorLabel: $t('Country Code'),
                        countrySelectorError: $t('Choose a country'),
                        phoneNumberLabel: $t('Mobile'),
                        example: $t('Example')+' :'
                      }"
                      :dark="$store.state.appConfig.layout.skin === 'dark'"
                      dark-color="#283046"
                      @update="updateMobile"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
                <b-button
                  type="submit"
                  variant="primary"
                  block
                  :disabled="loader"
                >
                  {{ $t('Send forgot code') }}
                  <b-spinner
                    v-if="loader"
                    small
                  />
                </b-button>
              </div>
              <div v-else>
                <div
                  class="text-muted my-2 text-center"
                >
                  {{ $t("Verify mobile number") }}
                </div>
                <div
                  class="d-flex justify-content-center"
                >
                  <h2
                    style="direction: ltr"
                  >
                    {{ fullMobile }}
                  </h2>
                </div>
                <b-form-group
                  label-for="code"
                  :label="$t('Verify Code')"
                  class="required"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="code"
                    rules="required|integer|length:6"
                  >
                    <b-form-input
                      id="code"
                      v-model="form.code"
                      name="code"
                      :placeholder="$t('Verify Code')"
                      class="verify-code-input form-control-dashed form-control-solid border-2 text-center h-auto"
                      maxlength="6"
                      autocomplete="new-password"
                    />
                    <div class="invalid-feedback">
                      {{ errors[0] }}
                    </div>
                  </validation-provider>
                </b-form-group>
                <b-form-group
                  label-for="password"
                  :label="$t('Password')"
                >
                  <validation-provider
                    #default="{ errors }"
                    :name="$t('Password')"
                    vid="password"
                    rules="required"
                  >
                    <b-input-group class="input-group-merge">

                      <b-form-input
                        id="password"
                        v-model="form.password"
                        :type="passwordFieldTypeNew"
                        :state="errors.length > 0 ? false : null"
                        name="password"
                        :placeholder="$t('Password')"
                      />

                      <b-input-group-append is-text>
                        <feather-icon
                          :icon="passwordToggleIconNew"
                          class="cursor-pointer"
                          @click="togglePasswordNew"
                        />
                      </b-input-group-append>
                    </b-input-group>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
                <b-form-group
                  label-for="password-confirmation"
                  :label="$t('Password Confirmation')"
                >
                  <validation-provider
                    #default="{ errors }"
                    :name="$t('Password Confirmation')"
                    vid="password-confirmation"
                    rules="required|confirmed:password"
                  >
                    <b-input-group class="input-group-merge">

                      <b-form-input
                        id="password-confirmation"
                        v-model="form.password_confirmation"
                        :type="passwordFieldTypeRetype"
                        :state="errors.length > 0 ? false : null"
                        name="password-confirmation"
                        :placeholder="$t('Password Confirmation')"
                      />

                      <b-input-group-append is-text>
                        <feather-icon
                          :icon="passwordToggleIconRetype"
                          class="cursor-pointer"
                          @click="togglePasswordRetype"
                        />
                      </b-input-group-append>
                    </b-input-group>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>

                <b-button
                  ref="formSubmit"
                  type="submit"
                  variant="primary"
                  class="font-weight-bold full-width"
                  :disabled="loader"
                >
                  {{ $t("Reset password") }}
                  <b-spinner
                    v-if="loader"
                    small
                  />
                </b-button>
                <div class="text-muted font-weight-bold mt-2">
                  {{ $t("Not receive code") }}
                  <b-button
                    variant="transparent"
                    class="text-primary text-hover-primary font-weight-extra-bold px-0"
                    @click="forgotPassword"
                  >
                    {{ $t("Resend code") }}
                  </b-button>
                  {{ $t("Or with us") }}
                  <router-link
                    class="text-primary text-hover-primary font-weight-extra-bold"
                    to="/contact-us"
                  >
                    {{
                      $t("Contact us")
                    }}
                  </router-link>
                </div>
              </div>
            </b-form>
          </validation-observer>

          <p class="text-center mt-2">
            <b-link :to="{name:'auth-login'}">
              <feather-icon icon="ChevronLeftIcon" /> {{ $t('Back to login') }}
            </b-link>
          </p>
        </b-col>
      </b-col>
      <!-- /Forgot password-->
    </b-row>
  </div>
</template>

<script>
/* eslint-disable global-require */
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BRow,
  BCol,
  BLink,
  BCardTitle,
  BCardText,
  BImg,
  BForm,
  BFormGroup,
  BFormInput,
  BButton,
  BSpinner,
  BInputGroup,
  BInputGroupAppend,
} from 'bootstrap-vue'
import VuexyLogo from '@core/layouts/components/Logo.vue'
import { required, email } from '@validations'
import store from '@/store/index'

export default {
  components: {
    VuexyLogo,
    BRow,
    BCol,
    BLink,
    BImg,
    BForm,
    BButton,
    BFormGroup,
    BFormInput,
    BSpinner,
    BCardTitle,
    BCardText,
    BInputGroup,
    BInputGroupAppend,
    ValidationProvider,
    ValidationObserver,
  },
  data() {
    return {
      loader: false,
      step: 1,
      form: {
        mobile: '',
        code: '',
        token: '',
        password: '',
        password_confirmation: '',
      },
      fullMobile: '',
      sideImg: require('@/assets/images/pages/forgot-password-v2.svg'),
      passwordFieldTypeNew: 'password',
      passwordFieldTypeRetype: 'password',
      // validation
      required,
      email,
    }
  },
  computed: {
    appConfig() {
      return store.state.app.appConfig
    },
    imgUrl() {
      if (store.state.appConfig.layout.skin === 'dark') {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.sideImg = require('@/assets/images/pages/forgot-password-v2-dark.svg')
        return this.sideImg
      }
      return this.sideImg
    },
    passwordToggleIconNew() {
      return this.passwordFieldTypeNew === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
    passwordToggleIconRetype() {
      return this.passwordFieldTypeRetype === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
  },
  methods: {
    togglePasswordNew() {
      this.passwordFieldTypeNew = this.passwordFieldTypeNew === 'password' ? 'text' : 'password'
    },
    togglePasswordRetype() {
      this.passwordFieldTypeRetype = this.passwordFieldTypeRetype === 'password' ? 'text' : 'password'
    },
    submit() {
      this.$refs.forgotPasswordForm.validate().then(success => {
        if (success) {
          if (this.step === 1) this.forgotPassword()
          else this.resetPassword()
        }
      })
    },
    forgotPassword() {
      this.loader = true
      this.$http.post('forgot-password', { mobile: this.form.mobile }).then(({ data }) => {
        this.loader = false
        this.form.token = data.token
        this.step = 2
      }).catch(() => {
        this.loader = false
      })
    },
    resetPassword() {
      this.loader = true
      this.$http.post('reset-password', this.form).then(() => {
        this.$router.push({ name: 'auth-login' }).then(() => {
          this.showSuccessNotification(this.$t('Reset password msg'))
        })
      }).catch(() => {
        this.loader = false
      })
    },
    updateMobile(e) {
      this.validMobile = e.isValid
      if (e.isValid) this.form.mobile = e.e164
    },
  },
}
</script>

<style lang="scss">
@import '~@core/scss/vue/pages/page-auth.scss';
</style>
